<template>
  <section class="container mx-auto px-4 md:px-8 py-10 md:py-14">
    <h1 class="text-3xl md:text-4xl font-extrabолд mb-6">
      Політика cookie та налаштування
    </h1>

    <div class="prose prose-neutral max-w-none">
      <p>
        Ми використовуємо cookie для коректної роботи сайту та покращення
        сервісу. Тут ви можете керувати своєю згодою.
      </p>

      <h2>Категорії cookie</h2>
      <ul>
        <li>
          <strong>Необхідні</strong> — забезпечують роботу сайту (кошик,
          авторизація). Увімкнені завжди.
        </li>
        <li>
          <strong>Аналітика</strong> — допомагає розуміти, як користуються
          сайтом.
        </li>
        <li><strong>Маркетинг</strong> — персоналізовані пропозиції.</li>
      </ul>

      <div class="mt-6 space-y-3">
        <label class="flex items-center gap-3">
          <input v-model="prefs.analytics" type="checkbox" />
          <span>Дозволити аналітику</span>
        </label>
        <label class="flex items-center gap-3">
          <input v-model="prefs.marketing" type="checkbox" />
          <span>Дозволити маркетинг</span>
        </label>
      </div>

      <div class="mt-6 flex gap-3">
        <button
          class="px-5 py-2 rounded-xl bg-pink-200 text-black hover:bg-pink-200/80"
          @click="save"
        >
          Зберегти
        </button>
        <button
          class="px-5 py-2 rounded-xl border hover:bg-gray-50"
          @click="allowAll"
        >
          Прийняти всі
        </button>
        <button
          class="px-5 py-2 rounded-xl border hover:bg-gray-50"
          @click="decline"
        >
          Лише необхідні
        </button>
      </div>

      <p class="text-sm text-gray-500 mt-8">
        Ви завжди можете змінити вибір на цій сторінці.
      </p>
    </div>
  </section>

  <!-- тости -->
  <UiToaster />
</template>

<script setup>
import { ref, watch } from "vue";
import UiToaster from "~/components/ui/UiToaster.vue";
import { useToast } from "~/composables/useToast";

const { show } = useToast();

const VERSION = "v1"; // змініть, щоб перепросити згоду
const prefs = ref(readPrefs());

function readPrefs() {
  try {
    const raw = localStorage.getItem("cookiePrefs");
    const v = localStorage.getItem("cookiePrefsVersion");
    if (raw && v === VERSION) return JSON.parse(raw);
  } catch {}
  return { analytics: false, marketing: false };
}
function writePrefs(p) {
  localStorage.setItem("cookiePrefs", JSON.stringify(p));
  localStorage.setItem("cookiePrefsVersion", VERSION);
  try {
    window.dispatchEvent(new CustomEvent("cookiePrefsUpdated"));
  } catch {}
}

function save() {
  writePrefs(prefs.value);
  show("Налаштування cookie збережено", { type: "success" });
}
function allowAll() {
  prefs.value = { analytics: true, marketing: true };
  save();
}
function decline() {
  prefs.value = { analytics: false, marketing: false };
  save();
}

watch(prefs, (v) => writePrefs(v), { deep: true });

useHead({
  title: "Політика cookie — mulberry’ss",
  meta: [
    {
      name: "description",
      content:
        "Керуйте згодою на аналітичні та маркетингові cookie. Необхідні cookie увімкнені завжди.",
    },
  ],
});
</script>
